function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e1) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e1) {
            op = [
                6,
                e1
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { connect } from "react-redux";
import { closeModal } from "@common/actions";
import CustomScrollbar from "@common/components/CustomScrollbar";
import { SCROLLBAR } from "@common/services/responsive";
import RichText from "@common/components/BoxDetailsTab/RichText";
import { hashCode } from "@common/utils/helpers";
import PrismicClient from "@common/utils/prismic";
import { SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR } from "@config/constants";
import { withSnackbar } from "notistack";
var PrivacyPolicy = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(PrivacyPolicy, Component);
    var _super = _create_super(PrivacyPolicy);
    function PrivacyPolicy(props) {
        _class_call_check(this, PrivacyPolicy);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            prismicData: null
        };
        _this.wrapperRef = null;
        _this.focusTimeout = null;
        return _this;
    }
    _create_class(PrivacyPolicy, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _async_to_generator(function() {
                    var prismicData, e1, _this_props_i18n_errors_prismic, localizedErrorMessage;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!PrismicClient.hasPrismic()) return [
                                    2
                                ];
                                _this.focusTimeout = setTimeout(function() {
                                    var _this_wrapperRef;
                                    (_this_wrapperRef = _this.wrapperRef) === null || _this_wrapperRef === void 0 ? void 0 : _this_wrapperRef.focus();
                                }, 0);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    PrismicClient.getTOS()
                                ];
                            case 2:
                                prismicData = _state.sent();
                                _this.setState({
                                    prismicData: prismicData[0]
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e1 = _state.sent();
                                localizedErrorMessage = ((_this_props_i18n_errors_prismic = _this.props.i18n.errors.prismic) === null || _this_props_i18n_errors_prismic === void 0 ? void 0 : _this_props_i18n_errors_prismic[e.message]) || _this.props.i18n.errors.generic;
                                _this.props.enqueueSnackbar(localizedErrorMessage, {
                                    variant: SNACKBAR_VARIANT_ERROR,
                                    autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                clearTimeout(this.focusTimeout);
            }
        },
        {
            key: "renderSectionText",
            value: function renderSectionText(text) {
                var elements = [];
                var lastItemType = null;
                var listChildren = [];
                var listItemKey = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = text.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _sliced_to_array(_step.value, 2), i = _step_value[0], item = _step_value[1];
                        var childKey = "".concat(i, "_").concat(hashCode(item.text));
                        if (lastItemType !== item.type) {
                            if (lastItemType === "o-list-item" || lastItemType === "list-item" && listChildren.length) {
                                elements.push(lastItemType === "o-list-item" ? /*#__PURE__*/ _jsx("ol", {
                                    children: listChildren
                                }, listItemKey) : /*#__PURE__*/ _jsx("ul", {
                                    children: listChildren
                                }, listItemKey));
                            }
                            listItemKey = null;
                            listChildren = [];
                        }
                        lastItemType = item.type;
                        switch(item.type){
                            case "paragraph":
                                elements.push(/*#__PURE__*/ _jsx(RichText, _object_spread({}, item), childKey));
                                break;
                            case "o-list-item":
                            case "list-item":
                                if (!listItemKey) {
                                    listItemKey = childKey;
                                }
                                listChildren.push(/*#__PURE__*/ _jsx("li", {
                                    children: /*#__PURE__*/ _jsx(RichText, _object_spread({
                                        style: {
                                            display: "inline"
                                        }
                                    }, item))
                                }, "li_".concat(childKey)));
                                break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (listChildren.length) {
                    elements.push(lastItemType === "o-list-item" ? /*#__PURE__*/ _jsx("ol", {
                        children: listChildren
                    }, listItemKey) : /*#__PURE__*/ _jsx("ul", {
                        children: listChildren
                    }, listItemKey));
                    listItemKey = null;
                    listChildren = [];
                }
                return /*#__PURE__*/ _jsxs("div", {
                    children: _to_consumable_array(elements)
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, _$closeModal = _this_props.closeModal, text = _this_props.text, screenType = _this_props.screenType;
                var prismicData = this.state.prismicData;
                if (!prismicData) return null;
                var content = /*#__PURE__*/ _jsxs("div", {
                    className: "message-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx("h1", {
                            children: prismicData.title
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "created font-weight-bold",
                            children: prismicData.created
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "font-weight-bold",
                            children: prismicData.valid_from
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "subtitle-holder",
                            children: prismicData.subtitle.map(function(data) {
                                return /*#__PURE__*/ _jsx(RichText, _object_spread({}, data), data.text);
                            })
                        }),
                        prismicData.section.map(function(param) {
                            var section_title = param.section_title, section_text = param.section_text;
                            return /*#__PURE__*/ _jsxs("div", {
                                className: "policy-section",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "policy-title",
                                        children: section_title
                                    }),
                                    _this.renderSectionText(section_text)
                                ]
                            }, section_title);
                        })
                    ]
                });
                return /*#__PURE__*/ _jsxs("div", {
                    ref: function(node) {
                        _this.wrapperRef = node;
                    },
                    className: "modal policy",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            onClick: _$closeModal,
                            onKeyDown: _$closeModal,
                            className: "icon icon-clear pointer"
                        }),
                        screenType.web ? /*#__PURE__*/ _jsx(CustomScrollbar, {
                            className: "privacy-policy-scrollbar",
                            hideTracksWhenNotNeeded: true,
                            style: {
                                width: SCROLLBAR.FAQ.width
                            },
                            thumbSize: SCROLLBAR.FAQ.thumbSize,
                            children: content
                        }) : content
                    ]
                });
            }
        }
    ]);
    return PrivacyPolicy;
}(Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n, screenType = param.screenType;
    return {
        i18n: i18n,
        screenType: screenType
    };
};
export default withSnackbar(connect(mapStateToProps, {
    closeModal: closeModal
})(PrivacyPolicy));
